import React from 'react';
import PropTypes from 'prop-types';

import { Text, Spacer } from '@zillow/constellation';

import SpinnerContainer from 'app/shared/components/SpinnerContainer';

const noop = () => {};

const propTypes = {
    propertyList: PropTypes.array,
    onLoadProperties: PropTypes.func,
};

const defaultProps = {
    propertyList: [],
    onLoadProperties: noop,
};

const ConsolidatedPropertyListModal = ({
    propertyList,
    onLoadProperties,
}) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [propertyNames, setPropertyNames] = React.useState(propertyList);

    React.useEffect(() => {
        if (propertyNames.length === 0 && onLoadProperties !== noop) {
            setIsLoading(true);
            onLoadProperties().then((newPropertyList) => {
                setIsLoading(false);
                setPropertyNames(newPropertyList);
            });
        }
    }, [onLoadProperties, propertyNames.length]);

    return (
        <Spacer marginX="md" marginBottom="md">
            {isLoading
                ? <SpinnerContainer />
                : propertyNames.map((name, i) => (
                    <Spacer marginY="xs">
                        <Text as="div" key={i}>{name}</Text>
                    </Spacer>
                ))
            }
        </Spacer>
    );
};

ConsolidatedPropertyListModal.propTypes = propTypes;
ConsolidatedPropertyListModal.defaultProps = defaultProps;

export default ConsolidatedPropertyListModal;
